'use strict';

bbw.service.chat.WebSocketClient = Class({

    /**
     * @type {bbw.WebSocket}
     */
    _ws: undefined,

    $q: undefined,

    _initDeferred: undefined,

    _messageSequence: 0,

    _initialMessage: undefined,

    /**
     * @type {bbw.service.chat.Client}
     */
    _serverMessageHandler: undefined,

    construct: function($q, ws) {
        this.$q = $q;
        this._ws = ws;
        this._ws.onMessage(this.onMessage.bind(this));
        this._ws.onError(this.onError.bind(this));
        this._ws.onClose(this.onClose.bind(this));
    },

    setHandler: function(serverMessageHandler) {
        this._serverMessageHandler = serverMessageHandler;

        return this;
    },

    onMessage: function(event) {
        var message;
        try {
            message = bbw.service.chat.Message.fromJson(event.data);
        } catch (e) {
            this._ws.disconnect();
            return;
        }

        if (this._initialMessage && message.isPairTo(this._initialMessage)) {
            this._handleInitResponse(message);
        } else {
            this._serverMessageHandler.onWsMessage(message);
        }
    },

    _handleInitResponse: function(message) {
        this._initialMessage = undefined;
        if (message.args.success) {
            this._initDeferred && this._initDeferred.resolve();
        } else {
            console.error('handleInitResponse error', message);
            this._initDeferred && this._initDeferred.reject(message.args.error || 'init_response_error');
        }
        this._initDeferred = undefined;
    },

    onError: function(event) {
        console.error && console.error(event);
        try {
            this._ws.disconnect();
        } catch (e) {
            // pass
        }
        this.onClose();
    },

    onClose: function() {
        if (this._initDeferred) {
            console.warn('close during init');
            this._initDeferred.reject('connection_failed');
            this._initDeferred = undefined;
        } else {
            this._serverMessageHandler.onWsClose();
        }
    },

    connect: function(initialMessage) {
        this._initDeferred = this.$q.defer();
        try {
            this._ws.connect();
            this._initialMessage = initialMessage;
            this.send(initialMessage);
        } catch (e) {
            this._initDeferred.reject(e);
        }
        return this._initDeferred.promise;
    },

    createMessage: function(method, args, id) {
        if (angular.isUndefined(id)) {
            id = ++this._messageSequence;
        }
        return new bbw.service.chat.Message(id, method, args);
    },

    send: function(message) {
        return this._ws.send(message.toJson());
    }

});
